import { gql } from '@apollo/client';

export const UPDATE_SOURCE_AREA_PROCESS = gql`
    mutation UpdateSourceAreaProcess($id: Guid!, $input: UpdateSourceAreaProcessPatch!) {
        facility {
            process {
                updateSourceAreaProcess(id: $id, input: $input) {
                    id
                }
            }
        }
    }
`;
